import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function Title() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const centered = !isDesktop || !isWideDesktop

  return (
    <Column alignCenter={centered} fullWidth>
      <AppearingWrapper centered={centered} kind="expand">
        <SubsectionTitle
          centered={centered}
          paragraph={
            <>
              A significant 71% of members have done business with each other,
              with a total of 96%{!centered ? <br /> : ' '}have referred shared
              connections.
            </>
          }
          subtitle="With 94% of our members being C-suite executives and business owners, you can forge genuine connections and strategic partnerships."
          title="Grow Your Network"
        />
      </AppearingWrapper>
    </Column>
  )
}

export default Title
